export * from "./empty-page-badge.component";
export * from "./empty-page-badge.module";
